module.exports = __webpack_public_path__ + "img/pined.8ff7dee6.svg";